import AuthService from "./auth";
import useProtoMethod from "./useProtoMethod";
import {
  CreateDocumentRequest,
  CreateDocumentResponse,
  GetDocumentRequest,
  GetDocumentResponse,
  GetOrCreateDocumentFromSourceRequest,
  GetOrCreateDocumentFromSourceResponse,
  UpdateDocumentRequest,
  UpdateDocumentResponse,
  ListDocumentsRequest,
  ListDocumentsResponse,
  CopyDocumentRequest,
  CopyDocumentResponse,
  CreateEmailDraftFromDocumentResponse,
  CreateEmailDraftFromDocumentRequest,
  ListFeaturedDocumentsResponse,
  ListFeaturedDocumentsRequest,
  ToggleDocumentFavoriteRequest,
  ToggleDocumentFavoriteResponse,
  ListDocumentTopicsRequest,
  ListDocumentTopicsResponse,
  ListFormResultsResponse,
  ListFormResultsRequest,
  ListMemberDocumentsResponse,
  ListMemberDocumentsRequest,
  CopyMemberDocumentResponse,
  CopyMemberDocumentRequest,
  CreateMemberDocumentResponse,
  CreateMemberDocumentRequest,
} from "protogen/documents_service_pb";

const useCreateDocument = (callback?: (r: CreateDocumentResponse) => void) => {
  return useProtoMethod<CreateDocumentRequest, CreateDocumentResponse>(
    "CreateDocument",
    CreateDocumentResponse,
    { callback },
  );
};

const useGetDocument = (callback?: (r: GetDocumentResponse) => void) => {
  return useProtoMethod<GetDocumentRequest, GetDocumentResponse>(
    "GetDocument",
    GetDocumentResponse,
    { callback },
  );
};

const useGetPublicDocument = (callback?: (r: GetDocumentResponse) => void) => {
  return useProtoMethod<GetDocumentRequest, GetDocumentResponse>(
    "GetPublicDocument",
    GetDocumentResponse,
    { callback },
  );
};

const fetchGetDocument = async (
  documentRef: string,
): Promise<GetDocumentResponse> => {
  const resp = await AuthService.protoMethod("GetDocument", { documentRef });
  return new GetDocumentResponse(resp.data);
};

const useGetOrCreateDocumentFromSource = (
  callback?: (r: GetOrCreateDocumentFromSourceResponse) => void,
) => {
  return useProtoMethod<
    GetOrCreateDocumentFromSourceRequest,
    GetOrCreateDocumentFromSourceResponse
  >("GetOrCreateDocumentFromSource", GetOrCreateDocumentFromSourceResponse, {
    callback,
  });
};

const useUpdateDocument = (callback?: (r: UpdateDocumentResponse) => void) => {
  return useProtoMethod<UpdateDocumentRequest, UpdateDocumentResponse>(
    "UpdateDocument",
    UpdateDocumentResponse,
    { callback },
  );
};

const useListDocuments = (callback?: (r: ListDocumentsResponse) => void) => {
  return useProtoMethod<ListDocumentsRequest, ListDocumentsResponse>(
    "ListDocuments",
    ListDocumentsResponse,
    { callback },
  );
};

const useCopyDocument = (callback?: (r: CopyDocumentResponse) => void) => {
  return useProtoMethod<CopyDocumentRequest, CopyDocumentResponse>(
    "CopyDocument",
    CopyDocumentResponse,
    { callback },
  );
};

const useCreateEmailDraftFromDocument = (
  callback?: (r: CreateEmailDraftFromDocumentResponse) => void,
) => {
  return useProtoMethod<
    CreateEmailDraftFromDocumentRequest,
    CreateEmailDraftFromDocumentResponse
  >("CreateEmailDraftFromDocument", CreateEmailDraftFromDocumentResponse, {
    callback,
  });
};

const useListFeaturedDocuments = (
  callback?: (r: ListFeaturedDocumentsResponse) => void,
) => {
  return useProtoMethod<
    ListFeaturedDocumentsRequest,
    ListFeaturedDocumentsResponse
  >("ListFeaturedDocuments", ListFeaturedDocumentsResponse, { callback });
};

const useToggleDocumentFavorite = (
  callback?: (r: ToggleDocumentFavoriteResponse) => void,
) => {
  return useProtoMethod<
    ToggleDocumentFavoriteRequest,
    ToggleDocumentFavoriteResponse
  >("ToggleDocumentFavorite", ToggleDocumentFavoriteResponse, { callback });
};

const useListDocumentTopics = (
  callback?: (r: ListDocumentTopicsResponse) => void,
) => {
  return useProtoMethod<ListDocumentTopicsRequest, ListDocumentTopicsResponse>(
    "ListDocumentTopics",
    ListDocumentTopicsResponse,
    { callback },
  );
};

const useListFormResults = (
  callback?: (r: ListFormResultsResponse) => void,
) => {
  return useProtoMethod<ListFormResultsRequest, ListFormResultsResponse>(
    "ListFormResults",
    ListFormResultsResponse,
    { callback },
  );
};

const useListMemberDocuments = (
  callback?: (r: ListMemberDocumentsResponse) => void,
) => {
  return useProtoMethod<
    ListMemberDocumentsRequest,
    ListMemberDocumentsResponse
  >("ListMemberDocuments", ListMemberDocumentsResponse, { callback });
};

const useCopyMemberDocument = (
  callback?: (r: CopyMemberDocumentResponse) => void,
) => {
  return useProtoMethod<CopyMemberDocumentRequest, CopyMemberDocumentResponse>(
    "CopyMemberDocument",
    CopyMemberDocumentResponse,
    { callback },
  );
};

const useCreateMemberDocument = (
  callback?: (r: CreateMemberDocumentResponse) => void,
) => {
  return useProtoMethod<
    CreateMemberDocumentRequest,
    CreateMemberDocumentResponse
  >("CreateMemberDocument", CreateMemberDocumentResponse, { callback });
};

export {
  useCreateDocument,
  useGetDocument,
  useGetPublicDocument,
  fetchGetDocument,
  useGetOrCreateDocumentFromSource,
  useUpdateDocument,
  useListDocuments,
  useCopyDocument,
  useCreateEmailDraftFromDocument,
  useListFeaturedDocuments,
  useToggleDocumentFavorite,
  useListDocumentTopics,
  useListFormResults,
  useListMemberDocuments,
  useCopyMemberDocument,
  useCreateMemberDocument,
};
